import { imgBaseURL } from "../config";

export default (url, prefix) => prefix ?? imgBaseURL + url;
